import { Label } from '@/components/ui/label';
import { SearchInput } from '@/components/ui/search-input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Spinner } from '@/components/ui/spinner';

import { useTrackedTables } from '@/hooks/useChangeHistory';
import { auditPeriodToStart, type AuditPeriod } from './_filter-options';
import { PeriodSelect } from './PeriodSelect';

export { auditPeriodToStart, type AuditPeriod };

const ACTION_OPTIONS = [
  { value: 'CREATE', label: 'Criação' },
  { value: 'UPDATE', label: 'Atualização' },
];

interface ChangeHistoryFilterBarProps {
  table: string;
  onTableChange: (value: string) => void;
  recordId: string;
  onRecordIdChange: (value: string) => void;
  action: string;
  onActionChange: (value: string) => void;
  period: AuditPeriod;
  onPeriodChange: (value: AuditPeriod) => void;
}

export function ChangeHistoryFilterBar({
  table,
  onTableChange,
  recordId,
  onRecordIdChange,
  action,
  onActionChange,
  period,
  onPeriodChange,
}: ChangeHistoryFilterBarProps) {
  const { data: tables, isLoading: tablesLoading } = useTrackedTables();

  return (
    <div className="space-y-3">
      {/* Filtros: entidade, ID, ação, período, por página */}
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end">
        <div className="space-y-1">
          <Label className="text-xs font-medium">Entidade</Label>
          {tablesLoading ? (
            <div className="flex h-9 items-center px-2">
              <Spinner size={16} />
            </div>
          ) : (
            <Select value={table} onValueChange={onTableChange}>
              <SelectTrigger className="w-full sm:w-[200px]">
                <SelectValue placeholder="Todas" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="__all__">Todas</SelectItem>
                {tables?.map((t) => (
                  <SelectItem key={t.table_name} value={t.table_name}>
                    {t.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          )}
        </div>

        <div className="space-y-1">
          <Label className="text-xs font-medium">ID do registro</Label>
          <SearchInput
            value={recordId}
            onChange={onRecordIdChange}
            placeholder="UUID do registro..."
            className="w-full sm:w-[280px]"
          />
        </div>

        <div className="space-y-1">
          <Label className="text-xs font-medium">Ação</Label>
          <Select value={action} onValueChange={onActionChange}>
            <SelectTrigger className="w-full sm:w-[140px]">
              <SelectValue placeholder="Todas" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="__all__">Todas</SelectItem>
              {ACTION_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <PeriodSelect<AuditPeriod>
          value={period}
          onChange={onPeriodChange}
          width="sm:w-[140px]"
        />
      </div>
    </div>
  );
}
